import { apiSlice } from "app/api/apiSlice";

export const RiskManagementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSurveyUploadCreation: builder.query({
      query: () => `/survey/creation-job`,
    }),
    getSurveyForms: builder.query({
      query: () => `/survey/master/survey-forms/?IsOperational=true`,
    }),
    getMasterClientList: builder.query({
      query: () => `/master/clients_master`,
    }),

    getStateList: builder.query({
      query: () => `/api/v1/master/states`,
    }),
    getMasterStateLevelNameData: builder.query({
      query: (Statecode, selectlevel) =>
        `/master/data_by_level_no/${Statecode}/${selectlevel}`,
    }),

    getSurveyAllocatedList: builder.query({
      query: (data) => `survey/${data.ST}/allocation/${data.Status}`,
    }),
    getGTSurveyInspection: builder.query({
      query: (data) => `survey/records/${data.ST}/${data.id}`,
    }),
    getCropList: builder.query({
      query: () => `/api/v1/master/crops?per_page=2000`,
    }),

    sendSurveyMaster: builder.mutation({
      query: (payload) => ({
        url: "/survey/creation-job",
        method: "POST",
        body: payload,
      }),
    }),

    getAgentUsers: builder.query({
      query: (id) => `/api/v1/onboarding/employees/FLE`,
    }),
    GetSurveyPrallocation: builder.query({
      query: (data) =>
        `survey/creation-job/view-creation/${data.listid}/?SurveyStatus=${data.Status}`,
    }),
    NewSUrveyDataApi: builder.query({
      query: (data) =>
        `survey/specific-survey-records/?formName=${data.ST}&AgentId=${data.AgentId}`,
    }),
    GetFilteredDataWithFilters: builder.query({
      query: (data) =>
        `survey/specific-survey-records/?formName=${data.ST}&StateId=${data.stateId}&Level3Id=${data.districtId}&Level4Id=${data.blockId}&per_page=${data.pagination.limit}&page=${data.pagination.currentPage}`,
    }),
    GetGTSurveyInspectionParticular: builder.query({
      query: (data) => `survey/records/${data.ST}/${data.userId}`,
    }),
    getCropSurvey: builder.query({
      query: ({ pagination, searchKey, dateKey }) =>
        `survey/crop-survey/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}`,
    }),
    UpdateSurveyBoundarybyid: builder.mutation({
      query: ({ ST, id, payload }) => ({
        url: `survey/${ST}/inspection/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    SurveyCheckerMaker: builder.mutation({
      query: (payload) => ({
        url: "/survey/creation-job",
        method: "POST",
        body: payload,
      }),
    }),
    getGtPointSurvey: builder.query({
      query: ({
        pagination,
        districtName,
        dateKey,
        CropName,
        gpName,
        VillageName,
        blockName,
        selectedLanguage,
      }) =>
        `/survey/gt-point-survey/?per_page=${pagination.per_page}&offset=${pagination.offset}&page=${pagination.currentPage}&state_name=UTTAR PRADESH&district_name=${districtName}&date=${dateKey}&crop_name=${CropName}&gp_name=${gpName}&village_name=${VillageName}&block_name=${blockName}&lang=${selectedLanguage}`,
      // query: ({pagination,districtName,dateKey,CropName,gpName,VillageName,blockName,selectedLanguage}) => `/survey/gt-point-dashboard/?per_page=${pagination.per_page}&offset=${pagination.offset}&page=${pagination.currentPage}&state_name=UTTAR PRADESH&district_name=${districtName}&date=${dateKey}&crop_name=${CropName}&gp_name=${gpName}&village_name=${VillageName}&block_name=${blockName}&lang=${selectedLanguage}`
    }),
    getGtPointSurveyOld: builder.query({
      query: ({
        pagination,
        searchKey,
        dateKey,
        selectedLanguage,
        state_name,
        district_name,
        qc_approved,
      }) =>
        `/survey/gt-point-survey/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}&lang=${selectedLanguage}&state_name=${state_name}&district_name=${district_name}&is_qc=${qc_approved}`,
    }),
    getGtPointHclDashboard: builder.query({
      query: ({
        pagination,
        searchKey,
        dateKey,
        selectedLanguage,
        state_name,
        district_name,
        qc_approved,
      }) =>
        `/survey/gt-point-dashboard/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}&lang=${selectedLanguage}&state_name=${state_name}&district_name=${district_name}&is_qc=${qc_approved}`,
    }),

    gtPointCreateBoundary: builder.mutation({
      query: ({ id, payload }) => ({
        url: `survey/gt-point-survey/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    GtSaathiAprrovalbyId: builder.mutation({
      query: ({ id, action }) => ({
        url: `survey/gt-point-survey/action/${id}`,
        method: `PATCH`,
        body: action,
      }),
    }),
    getLulcData: builder.query({
      query: ({
        districtName,
        type,
        gpName,
        VillageName,
        SeasonName,
        selectedSeasonalCropId,
        blockName,
      }) =>
        `dasp/layer?type=${type}&district_name=${districtName}&gp_name=${gpName}&village_name=${VillageName}&season=${SeasonName}&crop_class=${selectedSeasonalCropId}&block_name=${blockName}`,
    }),
    getUpDistricts: builder.query({
      query: (data) => `dasp/up-districts?lang=${data}`,
    }),
    getUpGp: builder.query({
      query: ({ districtName, blockName, selectedLanguage }) =>
        `dasp/up-gps?district_name=${districtName}&block_name=${blockName}&lang=${selectedLanguage}`,
    }),
    getUpVillage: builder.query({
      query: (gpCode) => `dasp/up-villages?gp_code=${gpCode}`,
    }),
    getUpBlocks: builder.query({
      query: ({ districtName, selectedLanguage }) =>
        `dasp/up-blocks/?district_name=${districtName}&lang=${selectedLanguage}`,
    }),
    getOverlapData: builder.query({
      query: ({ districtCrop, kharifCrop, RabiCrop }) =>
        `/dasp/overlap-analysis?district_name=${districtCrop}&kharif_class=${kharifCrop}&rabi_class=${RabiCrop}`,
    }),
    getSummaryYieldData: builder.query({
      query: ({ SeasonName, selectedSeasonalCrop, selectedEstimatedYield }) =>
        `/dasp/up-yield-summary?StateName=Uttar Pradesh&Crop=${selectedSeasonalCrop}&Season=${SeasonName}&Estimate=${selectedEstimatedYield}`,
    }),
    getFilteredYieldData: builder.query({
      query: ({ districtValue, SeasonName, selectedSeasonalCrop }) =>
        `/dasp/up-yields/?StateName=UTTAR PRADESH&DistName=${districtValue}&Crop=${selectedSeasonalCrop}&Season=${SeasonName}`,
    }),
    getCropListLang: builder.query({
      query: (selectedLanguage) =>
        `crop-master-records?lang=${selectedLanguage}`,
    }),
    getReportSurvey: builder.query({
      query: () => ({ url: `survey/summary-reports/?FormName=Gtpoint` }),
    }),
    // getDigitalAgriculture: builder.query({
    //   query: ({pagination,searchKey,dateKey}) => ({ url:`/survey/gt-digital-agriculture/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}`, }),
    // }),
   getDigitalAgriculture: builder.query({
  query: ({ pagination, searchKey, dateKey, surveyType }) => {
    const typeMap = {
      GT: "gt",
      CH: "ch",
      BM: "bm",
    };
    const typePath = typeMap[surveyType] || "gt";
    const extraParams =
      surveyType === "BM" ? "&lang=en&SurveyNo=&is_benchmark=no" : "";
    return {
      url: `/survey/${typePath}-digital-agriculture/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}${extraParams}`,
    };
  },
}),

     getDigitalAgricultureBenchmarkById: builder.query({
      query: ({pagination,SurveyNo}) => ({ url: `/survey/bm-digital-agriculture/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=&date=&lang=en&SurveyNo=${SurveyNo}&is_benchmark=yes` }),
    }),
      
     getReportSurveyDigitalAgriculture: builder.query({
      query: (formName) => ({ url: `survey/summary-reports/?FormName=${formName}` }),
    }),
      getDigitalAgricultureCH: builder.query({
      query: ({pagination,searchKey,dateKey}) => ({ url:`/survey/ch-digital-agriculture/?limit=${pagination.limit}&offset=${pagination.offset}&page=${pagination.currentPage}&search=${searchKey}&date=${dateKey}`, }),
    }),
     getSoilParameters: builder.query({
      query: ({FarmerId}) => ({ url: `survey/soil-parameters/?FarmerId=${FarmerId}` }),
    }),
  }),
});

export const {
  useGetSurveyUploadCreationQuery,
  useGetSurveyFormsQuery,
  useGetMasterClientListQuery,
  useGetStateListQuery,
  useGetMasterStateLevelNameDataQuery,
  useGetSurveyAllocatedListQuery,
  useGetGTSurveyInspectionQuery,
  useGetCropListQuery,
  useSendSurveyMasterMutation,
  useGetAgentUsersQuery,
  useGetSurveyPrallocationQuery,
  useNewSUrveyDataApiQuery,
  useGetFilteredDataWithFiltersQuery,
  useGetGTSurveyInspectionParticularQuery,
  useGetCropSurveyQuery,
  useUpdateSurveyBoundarybyidMutation,
  useSurveyCheckerMakerMutation,
  useGetGtPointSurveyQuery,
  useGtPointCreateBoundaryMutation,
  useGtSaathiAprrovalbyIdMutation,
  useGetLulcDataQuery,
  useGetUpDistrictsQuery,
  useGetGtPointSurveyOldQuery,
  useGetUpGpQuery,
  useGetUpVillageQuery,
  useGetOverlapDataQuery,
  useGetSummaryYieldDataQuery,
  useGetFilteredYieldDataQuery,
  useGetUpBlocksQuery,
  useGetCropListLangQuery,
  useGetReportSurveyQuery,
  useGetGtPointHclDashboardQuery,useGetDigitalAgricultureQuery,
  useGetReportSurveyDigitalAgricultureQuery,useGetDigitalAgricultureCHQuery,useGetDigitalAgricultureBenchmarkByIdQuery,useGetSoilParametersQuery
} = RiskManagementApiSlice;
